import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { Form } from 'reactstrap';
import { ModalDialog } from 'react-modal-dialog';
import { IconeCarregar } from '../../components/Icones';

@inject("store")
@observer
class LoadingPanel extends Component {

    constructor(props) {
        super(props);

        this.appStore = this.props.store.appStore;
    }

    render() {
        if (!this.props.isLoading) return <Fragment>{this.props.children}</Fragment>

        return (

            <Fragment>
                {!this.appStore.isMobile ? (
                    this.props.useModal ? (
                        <ModalDialog className="nosso-modal modal-margin" style={{ transition: 'left 1s linear 0s', ...(!this.appStore.sidebarFechado ? { left: 'calc(50vw - 236px)'} : {})}}>
                            <div className="text-center">
                                <h1>Aguarde por favor..</h1>
                                <IconeCarregar tamanho="2x"/>
                            </div>
                        </ModalDialog>
                    ) : (
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <div className="loading-panel">
                                    <h1>Aguarde por favor..</h1>
                                    <IconeCarregar tamanho="2x"/>
                                </div>
                            </Form>
                        </div>
                    )
                ) : (
                    <div className="loading-mobile">
                        <IconeCarregar tamanho="2x"/>
                    </div>
                )}
            </Fragment>
        );
    }
}





export { LoadingPanel }


// WEBPACK FOOTER //
// ./src/modules/comum/loading/components/LoadingPanel.js